export const TEXT = {
  ACCESS_CODE_ONLY: {
    title: "Enter your child's Access Code",
    helpPartOne: 'If you do not know your Access Code',
    helpPartTwo: 'choose "Continue without Access Code"',
    inputLabel: 'Access Code',
    infoEntryText: 'Continue without Access Code',
    ERROR_MESSAGE: {
      message: 'No student found with this Access Code. You may:',
      callToAction: 'Click "Continue without Access Code" below',
    },
  },
  DEFAULT: {
    title: "Enter your child's student I.D. number or Access Code.",
    helpPartOne: '',
    helpPartTwo: '',
    inputLabel: 'Student I.D.',
    infoEntryText: 'Continue without I.D.',
    ERROR_MESSAGE: {
      message: 'No student found with this I.D. You may:',
      callToAction: '',
    },
  },
  STUDENT_TEXT: {
    title: "Enter your child's Student ID",
    helpPartOne: "If you do not know your child's Student ID",
    helpPartTwo: 'choose "Continue without Student ID"',
    inputLabel: 'Student ID Number',
    infoEntryText: 'Continue without ID',
    ERROR_MESSAGE: {
      message: 'No student found with this I.D. You may:',
      callToAction: 'Continue without ID',
    },
  },
}
